import React from "react";
import PropTypes from "prop-types";
import { Col } from "react-bootstrap";
import { Field } from "redux-form";
import { NumberInput, Check } from "MODULES/shared/components/Forms";
import { translateProps } from "MODULES/shared/decorators";
import { EXPECTED_DATE } from "MODULES/SalesOrders/constants";
import { TAG_DATE } from "MODULES/inventories/constants";
import FormRow from "../../../../../shared/components/Forms/FormRow";
import {
  ESTIMATED_LEAD_TIME,
  REPAIR_AND_HOLD,
  REPAIR_AND_HOLD_LEAD_TIME
} from "../../../../constants";

const RepairAndHoldFields = ({ disabled, getField, setFieldValue }) => (
  <FormRow>
    <Col md={6}>
      <div className="form-group">
        <div
          className="btn-group btn-group-justified btn-group-vertical"
          data-toggle="buttons"
        >
          <label className="control-label" htmlFor={REPAIR_AND_HOLD}>
            Repair & Hold
          </label>
          <div style={{ backgroundColor: "#4CAF50", borderRadius: "5px" }}>
            <Field
              name={REPAIR_AND_HOLD}
              component={Check}
              label="Repair & Hold"
              icon="fa-check-circle"
              disabled={disabled}
              onChange={(_ev, val) => {
                if (val) {
                  [TAG_DATE, EXPECTED_DATE, ESTIMATED_LEAD_TIME].forEach(f =>
                    setFieldValue(f, null)
                  );
                } else {
                  setFieldValue(REPAIR_AND_HOLD_LEAD_TIME, null);
                }
              }}
            />
          </div>
        </div>
      </div>
    </Col>
    <Col md={6}>
      <RepairLeadTimeField getField={getField} disabled={disabled} />
    </Col>
  </FormRow>
);

const repairLeadTime = ({ disabled, repairAndHold }) => (
  <Field
    name={REPAIR_AND_HOLD_LEAD_TIME}
    component={NumberInput}
    inputProps={{
      max: "99"
    }}
    roundDigits={0}
    label="Repair & Hold LT"
    required={!!repairAndHold}
    disabled={disabled || !repairAndHold}
  />
);

const withRepairAndHold = translateProps(({ getField }) => ({
  repairAndHold: getField(REPAIR_AND_HOLD)
}));

const RepairLeadTimeField = withRepairAndHold(repairLeadTime);

export default RepairAndHoldFields;

RepairAndHoldFields.propTypes = {
  disabled: PropTypes.bool,
  getField: PropTypes.func.isRequired,
  setFieldValue: PropTypes.func.isRequired
};

repairLeadTime.propTypes = {
  disabled: PropTypes.bool,
  repairAndHold: PropTypes.bool
};



// WEBPACK FOOTER //
// ./app/modules/RepairOrders/components/Detail/LineItems/FormSections/RepairAndHoldSection.jsx